export default {
  'form.Submit': "提交",
  'form.cancel': "取消",
  'form.edit': "編輯",
  'form.view_table': "在表格中查看",
  'form.view_list': "在清單中查看",
  'form.select_item': "選擇 {item} ",
  'form.picked_item': "Picked {item} ",
  "form.upload.text": "點擊或拖曳文件到此處上傳。",
  "form.upload.hint": "支持單個或批量上傳。嚴禁上傳公司數據或受限文件。",
  'form.created_at': "創建時間",
  'form.updated_at': "更新時間",
  'form.download': "下載",
  "form.editable": "可編輯",
  
  'form.ev_charger.cha_id': "Id",
  'form.ev_charger.connectors.con_db_id': "Id",
  'form.ev_charger.connectors': "連接器",
  'form.ev_charger.connectors.add': "新增連接器",
  'form.ev_charger.connectors.con_id': "連接器 ID",
  'form.ev_charger.connectors.ev_system': "系統",
  'form.ev_charger.connectors.default_current': "默認電流",
  'form.ev_charger.connectors.min_current': "最小電流",
  'form.ev_charger.connectors.max_current': "最大電流",
  "form.ev_charger.connectors.id.not_unique": "連接器 ID 已被使用，請提供唯一的 ID。",

  'form.document.selects': "選擇文件",
  'form.document.document': "文件",
  'form.document.uid': "ownerId",
  'form.document.did': "Id",
  'form.document.file': "File",
  'form.document.file_path': "Path",
  'form.document.file_name': "文件標題",
  'form.document.document_type': "文件類型",
  'form.document.filesize': "文件大小",
  'form.document.view': "文件檢視",
  'form.document.null': "沒有相關文件",

  "ev_schedule.sch_id": "Id",
  "ev_schedule.schedule_start": "開始",
  "ev_schedule.schedule_not_start": "未開始",
  "ev_schedule.title": "標題",
  "ev_schedule.description": "描述",
  "ev_schedule.date_range": "日期範圍",
  "ev_schedule.time_range": "時間範圍",
  "ev_schedule.rate_method": "計算方式",
  "ev_schedule.min_interval": "最小間隔",
  "ev_schedule.min_interval.d": "0 = 無限制",
  "ev_schedule.interval": "間隔",
  "ev_schedule.rate": "費率",
  "ev_schedule.upper_limit_rate": "最高費率",
  "ev_schedule.round_method": "四捨五入方式",
  "ev_schedule.round_method.rounddown": "無條件捨去",
  "ev_schedule.round_method.roundup": "無條件進位",
  "ev_schedule.round_method.custom": "自訂四捨五入",
  "ev_schedule.round_method.round": "四捨五入",
  "ev_schedule.round_method.notround": "不四捨五入",
  "ev_schedule.recurs": "重複於",
  "ev_schedule.mon": "星期一",
  "ev_schedule.tue": "星期二",
  "ev_schedule.wed": "星期三",
  "ev_schedule.thu": "星期四",
  "ev_schedule.fri": "星期五",
  "ev_schedule.sat": "星期六",
  "ev_schedule.sun": "星期日",
  "ev_schedule.public_holiday": "公眾假期",
  "ev_schedule.priority": "優先級",

  "location.sch_id": "Id",
  'location.null': "沒有關聯位置",
  'location.location_id': "ID",
  'location.name_en': "名稱 (EN)",
  'location.name_tc': "名稱 (TC)",
  'location.name_sc': "名稱 (SC)",
  'location.address_en': "地址 (EN)",
  'location.address_tc': "地址 (TC)",
  'location.address_sc': "地址 (SC)",
  'location.public_description_en': "描述 (EN)",
  'location.public_description_tc': "描述 (TC)",
  'location.public_description_sc': "描述 (SC)",
  'location.contact_no': "聯繫電話",
  'location.latitude': "緯度",
  'location.longitude': "經度",
  'location.image': "圖像",

  'playlist.null': "沒有相關廣告",
  'playlist.playlist': "播放清單",
  'playlist.ad_id': "Id",
  'playlist.title': "標題",
  'playlist.description': "描述",
  'playlist.uid': "ownerId",
  'playlist.document.did': "Id",
  'playlist.document.order': "播放順序號",
  'playlist.document.display_seconds': "顯示秒數",
};
